import { render } from "./ParceirosView.vue?vue&type=template&id=5b6dcdaf&scoped=true"
import script from "./ParceirosView.vue?vue&type=script&lang=js"
export * from "./ParceirosView.vue?vue&type=script&lang=js"

import "./ParceirosView.vue?vue&type=style&index=0&id=5b6dcdaf&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6dcdaf"]])

export default __exports__